/**
 * Layout-only parent route for /admin/*.
 *
 * Every parent in the URL chain needs an `<Outlet />` for child routes
 * to mount; this file exists so `_app.admin.audit.tsx` (and any future
 * admin-only sub-route) can hang off `/admin`. Per-route admin gating
 * lives in the children's `beforeLoad` (and the server enforces it
 * regardless), so this layout is intentionally just a passthrough — no
 * shared chrome to drag in here yet.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin")({
  component: AdminLayout,
});

function AdminLayout() {
  return <Outlet />;
}
